/**
 * a helper method to capitalize a string
 * @param {string} word
 * @returns The string with the first character capitalized
 */
export function capitalize(word) {
  return word.charAt(0).toUpperCase() + word.slice(1);
}
